export const isDocTypeSelectedForAllFiles = ({ files }) =>
    files.every((file) => !!file.docType);

export const getFileExtension = (fileLink) => {
    return fileLink?.split('.').pop();
};
